export const SHOW_MEDIA_TYPE_VALUES = {
  VIDEO_PREVIEW: 1,
  COVER_IMAGE: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/show-media-type-values.js